export const toDate = stringDate => new Date(Date.parse(`${stringDate}T00:00:00`))
